import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreateOilStoreDto, OilStoreService } from 'services/openapi';

export const useCreateOilStoreMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: CreateOilStoreDto) =>
      OilStoreService.oilStoreControllerCreate(variables),
  });
};
